import React, { useState, useEffect } from 'react'
import {
  Main,
  Header,
  useGlobalAudio,
} from '@orbital/games-frontend-library'
import { TexasWrapper } from './TexasStyles'
import GameBoard from '../components/gameBoard/GameBoard'
import Footer from '../components/footer/Footer'

import { stateControl } from './helpers/stateControl'
// import useShowingResult from '../components/helpers/showingResult'
import useBalanceUpdate from './helpers/updateBalance'
import useWinCombinations from './helpers/getWinCombination'

export default function Game({
  gameInfo,
  stateRound,
  blur,
  colors,
  handleAbove,
  audio,
  handleNotification,
  texasSocketMessages,
  stakesForSocket,
  isError,
  showLoader,
}: any) {
  const SFXS = useGlobalAudio(audio.volume, audio.sound)
  // const { state, raise, playerWinType, playerWinPositions, turn } = stateRound
  const {
    state,
    raise,
    playerWinType,
    playerWinPositions,
    dealerWinPositions,
    dealerWinType,
    turn,
    river,
    totalWin,
    cards,
  } = stateRound
  const { precision, currency } = gameInfo

  const [player, setplayer] = useState<string[]>(['X0', 'X0'])
  const [dealPlayer, setdealPlayer] = useState<boolean>(false)

  const [dealer, setDealerCards] = useState<string[]>(['X0', 'X0'])
  const [dealDealer, setdealDealer] = useState<boolean>(false)

  const [raiseCards, setraiseCards] = useState<string[]>(['X0', 'X0', 'X0'])
  const [dealRaiseCards, setDealRaiseCards] = useState<boolean>(false)

  const [turnCard, setTurnCard] = useState<string>('X0')
  const [dealTurn, setdealTurn] = useState<boolean>(false)

  const [riverCard, setRiverCard] = useState<string>('X0')
  const [dealRiver, setdealRiver] = useState<boolean>(false)

  const [dealed, setdealed] = useState<boolean>(false)
  const [dealOut, setDealOut] = useState<boolean>(false)

  const [startDeal, setStartDeal] = useState<boolean>(false)

  const [flipCard, setflipCard] = useState<boolean>(false)
  const [isFold, setisFold] = useState<boolean>(false)
  // const isFold = state === 6 && cards[length - 1] === 'X0'

  const [showResult, setShowResult] = useState<boolean>(false)
  const handleShowResult = (b: boolean) => setShowResult(b)

  useEffect(() => {
    setdealed(false)
    isError &&
      setTimeout(() => {
        setdealed(true)
      }, 500)
  }, [isError])

  // useEffect(() => {
  //   if (isError) {
  //     if (!isFold && (state === 6 || state === 5 || state === 11)) {
  //       setisFold(true)
  //     }
  //   }
  // }, [isFold, isError, state])

  stateControl({
    state,
    stateRound,
    setdealed,
    setplayer,
    setdealPlayer,
    setraiseCards,
    setDealRaiseCards,
    setdealDealer,
    setTurnCard,
    setdealTurn,
    setRiverCard,
    setdealRiver,
    setflipCard,
    setDealerCards,
    setisFold,
    handleShowResult,
    setStartDeal,
  })
  const handleFoldAndDealOut = () => {
    texasSocketMessages.handleFold()
    setDealOut(true)
    setTimeout(() => {
      setDealOut(false)
      setdealPlayer(false)
      setdealDealer(false)
      setplayer(['X0', 'X0'])
    }, 600)
  }

  const handleDealOut = () => {
    setDealOut(true)
    setTimeout(() => {
      setDealOut(false)
      setdealPlayer(false)
      setdealDealer(false)
      setDealRaiseCards(false)
      setdealTurn(false)
      setdealRiver(false)
      setflipCard(false)
      setplayer(['X0', 'X0'])
      setDealerCards(['X0', 'X0'])
    }, 600)
  }

  const finalBalance = useBalanceUpdate(stateRound, showResult)

  const { winCombination, winType } = useWinCombinations(
    state,
    playerWinPositions,
    dealerWinPositions,
    playerWinType,
    dealerWinType,
  )

  return (
    <Main blur={blur}>
      <TexasWrapper>
        <Header
          title='Texas'
          gameInfo={gameInfo}
          colors={colors}
          handleAbove={handleAbove}
          sfx={SFXS.goForwardSFX}
          fontSize='24px'
          betInfoBalance={finalBalance}
          balanceUpdateOn='now'
        />
        <GameBoard
          player={player}
          dealPlayer={dealPlayer}
          dealer={dealer}
          dealDealer={dealDealer}
          raise={raiseCards}
          dealRaise={dealRaiseCards}
          turn={turnCard}
          dealTurn={dealTurn}
          river={riverCard}
          dealRiver={dealRiver}
          dealOut={dealOut}
          flipCard={flipCard}
          showResult={showResult}
          winCombination={winCombination}
          audio={audio}
          state={state}
          // isFold={isFold}
          showLoader={showLoader}
          startDeal={startDeal}
        />
        <Footer
          gameInfo={gameInfo}
          stakesForSocket={stakesForSocket}
          footerVariables={{
            currency,
            raise,
            precision,
            state,
            winType,
            turn,
            river,
            totalWin,
            isFold,
            audio,
          }}
          footerHandlers={{
            handleNotification,
            texasSocketMessages,
            handleFoldAndDealOut,
            handleDealOut,
          }}
          dealed={dealed}
        />
      </TexasWrapper>
    </Main>
  )
}
